<ca-card ui-3 class="mt-4 md-5" *ngIf="poliza">
    <div ca-card-title>{{'CONTRATAR_POLIZA.TITULO' | translate}}</div>
    <div ca-card-content>
        <form class="form" *ngIf="contratarForm" [formGroup]="contratarForm" (ngSubmit)="contratarPoliza()" >
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosPersonalesTomador">
                        <app-datos-personales 
                            [config]="tomadorConfig"
                            [form]="contratarForm.get('datosPersonalesTomador')"
                            (personaChange)="onTomadorChange($event)"></app-datos-personales>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>{{'COMUN.DATOS_DOMICILIO.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.TOMADOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosDomicilioTomador">
                        <app-datos-domicilio 
                            [config]="domicilioTomadorConfig"
                            [form]="contratarForm.get('datosDomicilioTomador')"
                            (domicilioChange)="onDomicilioTomadorChange($event)"></app-datos-domicilio>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="mostrarPropietario && propietarioConfig">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.PROPIETARIO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosPersonalesPropietario">
                        <app-datos-personales 
                            [config]="propietarioConfig"
                            [form]="contratarForm.get('datosPersonalesPropietario')"
                            (personaChange)="onPropietarioChange($event)"></app-datos-personales>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="mostrarPropietario && domicilioPropietarioConfig">
                <div ca-card-title>{{'COMUN.DATOS_DOMICILIO.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.PROPIETARIO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosDomicilioPropietario">
                        <app-datos-domicilio 
                            [config]="domicilioPropietarioConfig"
                            [form]="contratarForm.get('datosDomicilioPropietario')"
                            (domicilioChange)="onDomicilioPropietarioChange($event)"></app-datos-domicilio>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="mostrarConductor && conductorConfig">
                <div ca-card-title>{{'COMUN.DATOS_GENERALES.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.CONDUCTOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosPersonalesConductor">
                        <app-datos-personales 
                            [config]="conductorConfig"
                            [form]="contratarForm.get('datosPersonalesConductor')"
                            (personaChange)="onConductorChange($event)"></app-datos-personales>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="mostrarConductor && domicilioConductorConfig">
                <div ca-card-title>{{'COMUN.DATOS_DOMICILIO.TITULO' | translate}} {{'COMUN.DATOS_PERSONA.TIPO_PERSONA.CONDUCTOR' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosDomicilioConductor">
                        <app-datos-domicilio 
                            [config]="domicilioConductorConfig"
                            [form]="contratarForm.get('datosDomicilioConductor')"
                            (domicilioChange)="onDomicilioConductorChange($event)"></app-datos-domicilio>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>{{'COMUN.DATOS_CONTACTO.TITULO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosContacto">
                        <app-datos-contacto 
                            [form]="contratarForm.get('datosContacto')"
                            [datosContacto]="poliza.datosContacto"
                            [editable]="true"
                            (datosContactoChange)="onDatosContactoChange($event)"></app-datos-contacto>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3">
                <div ca-card-title>
                    {{'CATALOGO.DATOS_PAGO.TITULO' | translate}}
                </div>
                <div ca-card-content>
                    <div formGroupName="datosPago">
                        <app-datos-pago 
                            [cuenta]="poliza.medioPago?.cuentaBancaria"
                            [mediosPago]="catalogo?.mediosPago"
                            [form]="contratarForm.get('datosPago')"
                            [editable]="true"
                            (medioPagoChange)="onMedioPagoChange($event)"></app-datos-pago>
                    </div>
                </div>
            </ca-card>
            <ca-card ui-3 class="mt-3" *ngIf="poliza?.recibo && fraccionamientoSeleccionado">
                <div ca-card-title>{{'COMUN.DATOS_ECONOMICOS.TITULO' | translate}}</div>
                <div ca-card-content>
                        <app-datos-economicos 
                            [recibo]="poliza?.recibo"
                            [fraccionamiento]="fraccionamientoSeleccionado"></app-datos-economicos>
                </div>
            </ca-card>
           <ca-card ui-3 class="mt-3" *ngIf="catalogo?.idiomas?.length > 0">
                <div ca-card-title>{{'COMUN.DATOS_IDIOMA.TITULO' | translate}}</div>
                <div ca-card-content>
                    <div formGroupName="datosIdiomas">
                        <app-idiomas 
                            [idiomas]="catalogo?.idiomas"
                            [form]="contratarForm.get('datosIdiomas')"></app-idiomas>
                    </div>
                </div>
            </ca-card>
            <div class="mt-4 pb-4">
                <div class="float-left">
                    <button ca-button-secondary type="button" (click)="volver()" [disabled]="polizaContratada">            
                        <ca-icon>chevron_left</ca-icon>
                        {{'MAIN.BOTON_VOLVER' | translate}}
                    </button>
                </div> 
                <div class="float-right">
                    <button ca-button class="ca-btn-icon__container ml-2" type="submit" 
                        [disabled]="contratarForm.invalid || polizaContratada?.numeroPoliza">
                        <ca-icon>edit</ca-icon>
                        {{'MENU.PRIVADO.CONTRATAR' | translate}}                        
                    </button>
                </div>  
            </div>
        </form>
    </div>
</ca-card>